   
                        
  
                                                  
                          
   
import TaskQueue from "./queue";

const State = {
  WAITING: 'waiting',
  RUNNING: 'running'
};

const maxCircularNumber = 1000;

export default class Scheduler {
  constructor (app) {
    this.app = app;
    this.queue = [];
    this.watchers = {};
    this.index = 0;
    this.state = State.WAITING;
    this.circular = [];
  }

  setState (state) {
    this.state = state;
  }

  is (state) {
    return this.state === state;
  }

  enqueueWatcher (watcher) {
                                            
    if (!this.watchers[watcher.id]) {
      this.watchers[watcher.id] = true;

      switch (this.state) {
        case State.WAITING:
          this.queue.push(watcher);

          this.setState(State.RUNNING);

          TaskQueue.nextTick(this.execute, this, this.app);
          break;

        case State.RUNNING:
                                                                        
                                                                     
          let i = this.queue.length - 1;

          while (i >= 0 && this.queue[i].id > watcher.id) {
            i--
          }

          this.queue.splice(Math.max(i, this.index) + 1, 0, watcher);
      }
    }
  }

  execute () {
                               
                         
                                                                                
                                   
                                                                                
                                                              
                                                                              
                                      
    this.queue.sort((a, b) => a.id - b.id);

                                                                
                                  
    for (this.index = 0; this.index < this.queue.length; this.index++) {
      const watcher = this.queue[this.index];
      this.watchers[watcher.id] = null;
      watcher.run();

                                                       
      if (process.env.NODE_ENV === 'development' && this.watchers[watcher.id] != null) {
        this.circular[id] = (this.circular[id] || 0) + 1;
        if (this.circular[id] > maxCircularNumber) {
          this.app.error.warn(
            `Infinite loop for max 1000 times for key: ${watcher.path} ` +
            `and expression: ${watcher.expression}`
          );
          break;
        }
      }
    }

    this.reset();
  }

  reset () {
    this.queue.length = 0;
    this.watchers = {};
    this.circular = {};
    this.setState(State.WAITING);
  }
}



// WEBPACK FOOTER //
// ./src/observer/scheduler.js